import { authenticatedRestClient } from 'helpers/restclient';
import { getMasterOnBehalfOfHeader } from 'helpers/restclient/auth';

export default class BidSalesService {
	static instance = new BidSalesService();

	_endpoints = {
		bidUrl: '/api/timed_sales_offers',
		updateAutobidUrl: '/api/timed_sales_offers/update_autobid_amount',
		removeAutobidUrl: (maxBid, sourceTab) => `/api/auctions/autobids/${maxBid}/cancel?source_tab=${sourceTab}`,
		acceptOfferUrl: `/api/timed_sales_offers/accept`,
		//
		addToWatchlist: `/api/watched_vehicles`,
		watchlistBidSalesIds: `/api/watched_vehicles/bid_sales`,
		getBidHistory: (bidSaleId) => `/api/bid_sales/${bidSaleId}/bid_history`,
		getCounterOfferHistory: (bidSaleId) => `/api/bid_sales/${bidSaleId}/bid_history/counter_offers`,
		hideVehicle: `/api/hidden_vehicles`,
		unHideVehicle: (vehicleId) => `/api/hidden_vehicles/${vehicleId}`,
		getMarketData: (vehicleId) => `/api/market_data/${vehicleId}`,
		getMasterUsers: `/api/subordinates/users`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	bid = (data, masterOnBehalfOf) => {
		const endpoint = this._endpoints.bidUrl;
		return this.restClient.post(endpoint, data, getMasterOnBehalfOfHeader(masterOnBehalfOf));
	};

	updateAutobid = (data, masterOnBehalfOf) => {
		const endpoint = this._endpoints.updateAutobidUrl;
		return this.restClient.post(endpoint, data, getMasterOnBehalfOfHeader(masterOnBehalfOf));
	};

	removeAutobid = (maxBid, sourceTab, masterOnBehalfOf) => {
		const endpoint = this._endpoints.removeAutobidUrl(maxBid, sourceTab);
		return this.restClient.post(endpoint, {}, getMasterOnBehalfOfHeader(masterOnBehalfOf));
	};

	acceptOffer = (vehicleId, offerActivityId, amount, sourceTab, masterOnBehalfOf, acknowledged) => {
		const endpoint = this._endpoints.acceptOfferUrl;
		return this.restClient.post(
			endpoint,
			{
				amount,
				vehicle_id: vehicleId,
				offer_activity_id: offerActivityId,
				source_tab: sourceTab,
				...(acknowledged ? { acknowledged } : {}),
			},
			getMasterOnBehalfOfHeader(masterOnBehalfOf),
		);
	};

	addToWatchlist = (vehicleId, sourceTab, vdpType) => {
		const endpoint = this._endpoints.addToWatchlist;
		return this.restClient.post(endpoint, {
			source_tab: sourceTab,
			watched_vehicle: {
				vehicle_id: vehicleId,
			},
			vdp_type: vdpType,
		});
	};

	removeFromWatchlist = (vehicleId, sourceTab, vdpType) => {
		const endpoint = `${this._endpoints.addToWatchlist}/${vehicleId}`;
		return this.restClient.delete(
			endpoint,
			{},
			{
				source_tab: sourceTab,
				vdp_type: vdpType,
			},
		);
	};

	getBidHistory = (bidSaleId, page, cancelToken) => {
		const endpoint = this._endpoints.getBidHistory(bidSaleId);
		return this.restClient.get(endpoint, { page }, {}, cancelToken);
	};

	getCounterOfferHistory = (bidSaleId, loggedUser, masterOnBehalfOf) => {
		const endpoint = this._endpoints.getCounterOfferHistory(bidSaleId);
		return this.restClient.get(
			endpoint,
			{ observer_id: loggedUser.user_id },
			getMasterOnBehalfOfHeader(masterOnBehalfOf),
		);
	};

	hideVehicle = (vehicleId, vdpType, sourceTab) => {
		const endpoint = this._endpoints.hideVehicle;
		return this.restClient.post(endpoint, { vehicle_id: vehicleId, vdp_type: vdpType, source_tab: sourceTab });
	};

	unHideVehicle = (vehicleId, vdpType, sourceTab) => {
		const endpoint = this._endpoints.unHideVehicle(vehicleId);
		return this.restClient.delete(
			endpoint,
			{},
			{
				vehicle_id: vehicleId,
				vdp_type: vdpType,
				source_tab: sourceTab,
			},
		);
	};

	getMarketData = (vehicleId) => {
		const endpoint = `${this._endpoints.getMarketData(vehicleId)}`;
		return this.restClient.get(endpoint, {});
	};

	getMasterUsers = (vehicleId) => {
		const endpoint = this._endpoints.getMasterUsers;
		return this.restClient.get(endpoint, { vehicle_id: vehicleId });
	};
}
